export default __webpack_public_path__ + "static/media/192-type2.3fc8a8c7.png";